<template>
    <div>
        <div class="row text-center">
            <div class="col-lg-3 col-12 mt-2 d-inline-block">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">انتخاب سرفصل</span>
                    </div>
                    <vs-select :data="mainAccounts" :mode="'create'"
                               :header="{multiple: false, label: 'title'}"
                               @onChange="onChange"></vs-select>
                </div>
            </div>
            <div class="col-lg-3 col-12 mt-2 d-inline-block">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text">زیر سرفصل :</span>
                    </div>
                    <vs-select :data="cashs" :mode="'create'"
                               :selected-val="selectedCash"
                               :header="{multiple: false, label: 'outSourceName'}"
                               @onChange="onChange2"></vs-select>

                </div>
            </div>
            <div class="col-lg-6 col-12 mt-2">
                <div class=" d-inline-block mx-3">
                    <div class="input-group mb-2">
                        <button type="button" class="d-inline-block btn btn-success" @click="onPrintClicked"><i
                                class="fa fa-print"></i></button>
                        <div class="input-group-prepend " @click="toggleStartDatePicker">
                            <div class="input-group-text"><span>از تاریخ :</span></div>
                        </div>
                        <date-picker type="date" :auto-submit="true" format="jYYYY-jMM-jDD" @input="onStartDatePicked"
                                     ref="datePickerStart" style="flex: 1">
                            <slot>
                                <input v-model="startDatePersian" class="form-control date-input" readonly="true"
                                       @click="toggleStartDatePicker">
                                <button class="close reset-date" @click="resetStartDate">×</button>
                            </slot>
                        </date-picker>
                    </div>
                </div>
                <div class="d-inline-block">
                    <div class="input-group mb-2">
                        <div class="input-group-prepend" @click="toggleEndDatePicker">
                            <div class="input-group-text"><span>تا تاریخ :</span></div>
                        </div>
                        <date-picker type="date" :auto-submit="true" :disable="startDatePersian" format="jYYYY-jMM-jDD"
                                     @input="onEndDatePicked"
                                     ref="datePickerEnd" style="flex: 1; transform">
                            <slot>
                                <input v-model="endDatePersian" class="form-control date-input" readonly="true"
                                       @click="toggleEndDatePicker">
                                <button class="close reset-date" @click="resetEndDate">×</button>
                            </slot>
                        </date-picker>
                    </div>
                </div>

                <!--<div class="d-inline-block mx-3">-->
                <!--<button class="btn btn-primary" @click="getReport">ثبت</button>-->
                <!--</div>-->
            </div>
        </div>
        <hr/>

        <!--<div v-if="transactions.length < dataCount" class="col-lg-12 text-center mb-3" @click="getTransactions">-->
        <!--<button class="btn btn-success">نمایش اسناد بیشتر</button>-->
        <!--</div>-->

        <div class="row">
            <div v-if="transactions === undefined || transactions.length ==0" class="col-lg-12 text-center mt-5 mb-3">
                <h3 class="no-item-alert">گزارشی یافت نشد!</h3>
            </div>
            <div v-else class="table-responsive col-12" id="printMe">
                <table class="table table-hover table-striped">
                    <thead>
                    <tr>
                        <th class="text-center text-nowrap">تاریخ</th>
                        <th class="text-center text-nowrap">نام حساب</th>
                        <th class="text-center text-nowrap">شماره سند</th>
                        <th class="text-center text-nowrap">شرح سند</th>
                        <th class="text-center text-nowrap">بدهکار</th>
                        <th class="text-center text-nowrap">بستانکار</th>
                        <th class="text-center text-nowrap">مانده</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item,index) in transactions">
                        <td class="text-center">{{item.persianDate}}</td>
                        <td class="text-center">{{item.account}}</td>
                        <td class="text-center">{{item.voucherNumber}}</td>
                        <td class="text-center" style="word-wrap: break-word;">{{item.description}}</td>
                        <td class="text-center">{{item.debtor.toLocaleString()}}</td>
                        <td class="text-center">{{item.creditor.toLocaleString()}}</td>
                        <td class="text-center">{{item.remains < 0 ? "("+(item.remains * -1).toLocaleString() +")-" : item.remains.toLocaleString()}}</td>
                    </tr>
                    <tr>
                        <td class="text-center" colspan="4"><b>مجموع</b></td>
                        <td class="text-center"><b>{{totalDebtor.toLocaleString() }}</b></td>
                        <td class="text-center"><b>{{totalCreditor.toLocaleString()}}</b></td>
                        <td class="text-center"><b>{{totalRemain <0 ?"(" + (totalRemain*-1).toLocaleString() +")-" :totalRemain.toLocaleString() }}</b></td>
                    </tr>

                    </tbody>
                </table>
            </div>
            <div v-if="transactions !== undefined && transactions.length < dataCount" class="col-lg-12 text-center mb-3"
                 @click="getTransactions">
                <button class="btn btn-success">نمایش تراکنش های بیشتر</button>
            </div>
            <div class="col-lg-12">
                <div class="sk-circle" id="loading">
                    <div class="sk-circle1 sk-child"></div>
                    <div class="sk-circle2 sk-child"></div>
                    <div class="sk-circle3 sk-child"></div>
                    <div class="sk-circle4 sk-child"></div>
                    <div class="sk-circle5 sk-child"></div>
                    <div class="sk-circle6 sk-child"></div>
                    <div class="sk-circle7 sk-child"></div>
                    <div class="sk-circle8 sk-child"></div>
                    <div class="sk-circle9 sk-child"></div>
                    <div class="sk-circle10 sk-child"></div>
                    <div class="sk-circle11 sk-child"></div>
                    <div class="sk-circle12 sk-child"></div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import * as $ from 'jquery';
    import Vue from 'vue';
    import BaseService from "../../_framework/api/BaseService";
    import Utils from "../../_framework/utils/Utils";
    import Moment from "moment-jalali";
    import EventBus from "../../_framework/event-bus.js";
    import DatePicker from '../../components/vue-persian-datetime-picker/VuePersianDatetimePicker.vue';
    import VsSelect from "../../_framework/VsSelect"
    import VueHtmlToPaper from 'vue-html-to-paper';


    $(function () {
        var pos1 = 0;
        $(window).scroll(function () {
            var pos2 = $(window).scrollTop();
            if (pos2 > pos1) {
                $(".search-area").addClass("hidden");
            }
            if (pos1 > pos2) {
                $(".search-area").removeClass("hidden");
            }
            pos1 = pos2;
        })
    });

    export default {
        name: 'book-report',
        components: {
            DatePicker,
            VsSelect,
        },
        data() {
            return {
                transactions: [],
                queryParams: {
                    pageSize: 100000,
                    pageIndex: 0,
                    type: 1
                },
                queryParams2: {
                    pageSize: 100000,
                    pageIndex: 0,
                    parrentId: 1
                },
                dataCount: 0,

                listView: false,
                fromDate: "",
                fromDateJ: "",
                toDate: "",
                toDateJ: "",
                startDatePersian: "",
                endDatePersian: "",
                providers: [],


                totalDebtor: 0,
                totalCreditor: 0,
                totalRemain: 0,
                mainAccounts: [],
                //     {id: 0, title: "همه حسابها"},
                //     {id: 1, title: "بانکها"},
                //     {id: 2, title: "صندوقها"},
                //     {id: 3, title: "مشتریها"},
                //     {id: 5, title: "تامین کننده ها"},
                //     {id: 6, title: "سرمایه(موجودی اولیه)"},
                //     {id: 7, title: "درآمدها"},
                //     {id: 8, title: "هزینه ها"},
                //     // {id: 9, title: "تولید"},
                //     {id: 10, title: "فروش ها"},
                //     {id: 11, title: "خریدها"},
                //     {id: 12, title: "چکهای دریافتی"},
                //     {id: 13, title: "چکهای پرداختی"},
                //
                //     {id: 15, title: "موجودی اولیه کالا"},
                //
                //     {id: 4, title: "اشخاص"},
                //     {id: 16, title: "شرکاء"},
                //     {id: 17, title: "دارائی ها"},
                //     {id: 18, title: "بدهی ها"},
                //
                //     {id: 20, title: "سایر سرفصلها"},
                // ],
                cashs: [],
                selectedMain: 0,
                selectedCash: {},
                keepData: false,
                showCash: false,
            }
        },
        mounted() {
            const printoptions = {
                name: '_blank',
                specs: [
                    'fullscreen=yes',
                    'titlebar=yes',
                    'scrollbars=yes'
                ],
                styles: [
                    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
                    'https://unpkg.com/kidlat-css/css/kidlat.css'
                ]
            };
            Vue.use(VueHtmlToPaper, printoptions);
            this.listView = JSON.parse(localStorage.getItem("listView"));
            EventBus.$on('listView', value => {
                this.listView = value;
            });
            this.getReport();
            this.getAllMains();
            // this.getProviders();
        },
        methods: {
            getAllMains() {
                new BaseService('AccountTitle', '/GetAllHead').getList().then(response => {
                    let a = response.data;
                    this.mainAccounts = [];
                    let bb = {id: 0, title: "همه حسابها", code: 0};
                    this.mainAccounts.push(bb);
                    for (let i of a) {
                        switch (i.id) {
                            case 1:
                                i.title = "بانکها";
                                break;
                            case 2:
                                i.title = "صندوق ها";
                                break;
                            case 3:
                                i.title = "مشتری ها";
                                break;
                            case 4:
                                i.title = "اشخاص";
                                break;
                            case 5:
                                i.title = "تامین کننده ها";
                                break;
                            case 6:
                                i.title = "سرمایه(موجودی اولیه)";
                                break;
                            case 7:
                                i.title = "درآمدها";
                                break;
                            case 8:
                                i.title = "هزینه ها";
                                break;
                            case 10:
                                i.title = "فروش";
                                break;
                            case 11:
                                i.title = "خرید";
                                break;
                            case 12:
                                i.title = "چک های دریافتی";
                                break;
                            case 13:
                                i.title = "چک های پرداختی";
                                break;
                            case 14:
                                i.title = "";
                                break;
                            case 15:
                                i.title = "موجودی اولیه کالا";
                                break;
                            case 16:
                                i.title = "شرکاء";
                                break;
                            case 17:
                                i.title = "دارائی ها";
                                break;
                            case 18:
                                i.title = "بدهی ها";
                                break;
                            case 20:
                                i.title = "سرفصلهای حسابداری";
                                break;

                        }
                        this.mainAccounts.push(i);
                    }
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            getTransactions() {
                this.queryParams.pageIndex++;
                this.keepData = true;
                $("#loading").show();
                this.getReport();
            },
            onCardClicked(e, index) {
                /*this.overallAmount = 0;
                let id = this.vouchers[index].id;
                new BaseService('voucher', `/getproducts/${id}`).getList().then(response => {
                    this.voucher = response.data;
                    for (let item of this.voucher.products) {
                        this.overallAmount += item.unitVal;
                    }
                    $("#voucherData").modal("show");
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                })*/
            },
            getProviders() {
                new BaseService('outsource', '/getlist').getList(this.queryParams2).then(response => {
                    this.cashs = response.data.data;
                    // console.log(this.banks);
                    let allPro = {
                        id: 0,
                        outSourceName: "همه موارد"
                    };
                    // this.banks.push(allPro);
                }).catch(error => {
                    // error
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });
            },
            toggleStartDatePicker() {
                this.$refs.datePickerStart.togglePicker();
            },
            toggleEndDatePicker() {
                this.$refs.datePickerEnd.togglePicker();
            },
            onStartDatePicked(val) {
                this.fromDate = Moment(val, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                this.startDatePersian = Moment(val, 'jYYYY-jMM-jDD').format('jDD jMMMM jYYYY');
            },
            onEndDatePicked(val) {
                this.toDate = Moment(val, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
                this.endDatePersian = Moment(val, 'jYYYY-jMM-jDD').format('jDD jMMMM jYYYY');
                // this.queryParams.accountTitleId = this.selectedBank !== 0 ? this.selectedBank : this.selectedCash;

                this.queryParams.fromdate = this.fromDate;
                this.queryParams.toDate = this.toDate;
                this.queryParams.pageSize = 10000;
                this.queryParams.pageIndex = 0;
                this.queryParams.type = 1;


                this.keepData = false;
                this.getReport();
            },
            resetStartDate() {
                this.fromDate = '';
                this.startDatePersian = '';
            },
            resetEndDate() {
                this.toDate = '';
                this.endDatePersian = '';
            },
            getReport() {
                if (!this.keepData) {
                    this.transactions = [];
                    this.totalDebtor = 0;
                    this.totalCreditor = 0;
                    this.totalRemain = 0;
                }
                new BaseService('reports', '/GetBookReport').getList(this.queryParams).then(response => {
                    let actions = response.data.data;
                    this.dataCount = response.data.count;
                    // this.totalDebtor = 0;
                    // this.totalCreditor = 0;
                    // this.totalRemain = 0;
                    if (actions !== undefined || actions != null) {
                        let remains = this.totalRemain;
                        for (let item of actions) {
                            let date = Moment(item.date, 'YYYY-MM-DD').format("jDD jMMMM jYYYY");
                            Vue.set(item, "persianDate", date);
                            item.remains = item.debtor - item.creditor + item.remain + remains;
                            remains = item.remains;
                            this.totalDebtor = this.totalDebtor + item.debtor;
                            this.totalCreditor = this.totalCreditor + item.creditor;
                            this.totalRemain = remains;
                            switch (item.outSourceType) {
                                case 6:
                                    item.account = "سرمایه(موجودی اولیه)";
                                    break;
                                case 10:
                                    item.account = "فروش";
                                    break;
                                case 11:
                                    item.account = "خرید";
                                    break;

                            }
                            this.transactions.push(item);
                        }
                    }
                    $("#loading").hide();
                }).catch(error => {
                    Utils.handleErrorWithNotification(error.message, this.$noty);
                });

            },
            onChange(val) {
                if(val) {
                    if (val.id === 0) {
                        this.showCash = false;
                    } else {
                        this.showCash = true;
                    }
                    this.selectedMain = parseInt(val.code);
                    this.keepData = false;
                    this.queryParams = {
                        outsourceType: this.selectedMain,
                        pageSize: 100000,
                        pageIndex: 0,
                        type: 1
                    };

                    // this.queryParams.outsourceType = this.selectedMain;
                    // this.queryParams.pageIndex = 0;
                    this.cashs = [];
                    this.selectedCash.outSourceName = "";
                    this.getReport();
                    this.queryParams2.types = this.selectedMain;
                    this.getProviders();
                }
            },
            onChange2(val) {
                if(val) {
                    this.queryParams.outsourceId = val.id;
                    this.keepData = false;
                    this.selectedCash = val;
                    this.queryParams.pageIndex = 0;
                    this.getReport();
                }
            },
            onPrintClicked() {
                this.$htmlToPaper('printMe');
            },


        }
    }
</script>